import React from "react";
import { Col, Row, Switch } from "antd";
import DefectRegister from "../../store/defectRegister";
import { observer } from "mobx-react-lite";
import Districts from "../../store/Districts";
import { toJS } from "mobx";
import { log } from "util";

const SwitchDistrict = observer(({ title, districtId }): React.FC => {
  const [check, setCheck] = React.useState(
    DefectRegister.initialFilter.districtIds.includes(districtId),
  );
  let timer;
  const switchHandler = (e) => {
    console.log(e);
    if (!DefectRegister.initialFilter.districtIds.includes(districtId)) {
      DefectRegister.initialFilter.districtIds.push(districtId);
      setCheck(DefectRegister.initialFilter.districtIds.includes(districtId));

      console.log(toJS(DefectRegister.initialFilter.districtIds), "add");
    } else {
      for (
        let i = DefectRegister.initialFilter.districtIds.length - 1;
        i >= 0;
        i--
      ) {
        if (DefectRegister.initialFilter.districtIds[i] === districtId) {
          DefectRegister.initialFilter.districtIds.splice(i, 1);
        }
      }
      setCheck(DefectRegister.initialFilter.districtIds.includes(districtId));
      if (!DefectRegister.initialFilter.eventLevel?.length) {
        DefectRegister.initialFilter.eventLevel = null;
      }
      console.log(toJS(DefectRegister.initialFilter.districtIds), "for");
    }
    if (!DefectRegister.initialFilter.districtIds.length) {
      DefectRegister.initialFilter.districtIds.push(20);
    }
    toJS(DefectRegister.initialFilter.districtIds);

    if (timer) {
      clearTimeout(timer);
      timer = 0;
    }
    timer = setTimeout(() => {
      DefectRegister.getRegistry();
      Districts.setLayers(districtId, e);
    }, 2000);
  };

  return (
    <li className={"filter-switch"}>
      <Row>
        <Col span={4}>
          <Switch
            checked={check}
            onChange={(e) => {
              switchHandler(e);
            }}
          />
        </Col>
        <Col span={20}>
          <p>{title}</p>
        </Col>
      </Row>
    </li>
  );
});

export default SwitchDistrict;
